export default "__VITE_ASSET__QyPK$c9t__"